import { createReactQueryHooks } from "@trpc/react"
import type { AppRouter } from "../../../../backend/src/trpc/trpcRouter"

export const TRPC_URL = "/api/trpc"

export const trpc = createReactQueryHooks<AppRouter>()

export type TRpcRawClient = ReturnType<typeof trpc.createClient>
